import { render, staticRenderFns } from "./EditNotifications.vue?vue&type=template&id=54dad858"
import script from "./EditNotifications.vue?vue&type=script&lang=js"
export * from "./EditNotifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports